window.showOverlay = function() {
  const overlay = document.getElementById("loading-overlay");
  overlay.classList.add("active");

  // find the visible slideshow
  const slideshows = overlay.querySelectorAll('.slideshow');
  let visibleSlideshow = null;

  slideshows.forEach(s => {
    const display = window.getComputedStyle(s).display;
    if (display !== 'none') visibleSlideshow = s;
  });

  if (!visibleSlideshow) return;

  const images = visibleSlideshow.querySelectorAll('img');
  let current = 0;

  // reset states
  images.forEach(img => img.classList.remove('active'));
  images[current].classList.add('active');

  // Run slideshow
  const interval = setInterval(() => {
    images[current].classList.remove('active');
    current++;

    if (current < images.length) {
      images[current].classList.add('active');
    } else {
      // Keep the last image visible and stop interval
      images[images.length - 1].classList.add('active');
      clearInterval(interval);
    }
  }, 1200);
};
